import { useTranslation } from 'react-i18next';
import useStrategicImperativeFormSchema from './StrategicImperativeForm.schema';
import { StrategicImperativeFormConfigType } from './StrategicImperativeForm.types';
import useTherapeuticAreaOptions from 'basics/options/therapeuticArea.options';
import { StrategicImperative } from 'generated/maya.types';

const useStrategicImperativeFormConfig = (strategicImperative: StrategicImperative | undefined) => {
  const { t } = useTranslation();
  const strategicImperativeFormSchema = useStrategicImperativeFormSchema();
  const strategicImperativeFormConfig: StrategicImperativeFormConfigType = {
    title: {
      label: t('maya_strategic_imperative_form_title_label'),
      name: 'title',
      placeholder: t('maya_strategic_imperative_form_title_placeholder'),
      required: true,
      defaultValue: strategicImperative?.title.trim() || '',
      validation: strategicImperativeFormSchema.title,
    },
    description: {
      label: t('maya_strategic_imperative_form_description_label'),
      name: 'description',
      placeholder: t('maya_strategic_imperative_form_description_label'),
      required: false,
      defaultValue: strategicImperative?.description || '',
      multiline: true,
      rows: 4,
      validation: strategicImperativeFormSchema.description,
    },
    therapeuticArea: {
      label: t('maya_strategic_imperative_form_therapeutic_area_label'),
      name: 'therapeuticArea',
      placeholder: t('maya_strategic_imperative_form_therapeutic_area_placeholder'),
      options: useTherapeuticAreaOptions(),
      defaultValue: strategicImperative?.therapeuticArea || '',
      required: true,
      validation: strategicImperativeFormSchema.therapeuticArea,
    },
    year: {
      label: t('maya_strategic_imperative_form_year_label'),
      name: 'year',
      placeholder: t('maya_strategic_imperative_form_year_placeholder'),
      defaultValue: strategicImperative?.year.toString(),
      required: true,
      type: 'number',
      validation: strategicImperativeFormSchema.year,
    },
  };

  return { strategicImperativeFormConfig };
};

export default useStrategicImperativeFormConfig;
